import { createFileRoute } from '@tanstack/react-router'
import { ApiFetchError } from '@/features/api-fetch-error/api-fetch-error'
import { useOidc } from '@/features/oidc/oidc'

export const Route = createFileRoute('/_app/account-locked/error')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const oidc = useOidc({ assert: 'user logged in' })

  return (
    <ApiFetchError
      onRetry={async () => {
        // there is chance that Player refreshed a page and newer frontend experiences loaded
        // but token still has old capabilities, and Player landed on that error page
        // clicking on the refresh button should forcefully update tokens and
        // sync them with frontend experiences
        await oidc.renewTokens()
        navigate({ to: '/' })
      }}
    />
  )
}
